export default __webpack_public_path__ + "static/media/complaints.ec37f92d.svg";